export const checkRouteAccess = (path, sharedData) => {
  const type = sessionStorage.getItem("type");
  const firstName = sessionStorage.getItem("firstName");

  if (!firstName) return false;

  if (["", "IT", "S", "D", "CS", "I", "CSM"].includes(type)) {
    if (path.includes("/users")) return false;
  }

  if (type === "SP" || type === "SA") {
    if (path.includes("/users") || path.includes("/inbox")) return false;
  }

  if (path.includes("/ticketDetail") && sharedData.setCurrentTicketNo === "") {
    return false;
  }

  if (path.includes("/client-detail") && sharedData.currentClientId === "") {
    return false;
  }

  return true;
};
